import { onPing } from 'modules/conference/actions/connectionMeter';
import createAction from './';

export const SHOW_APPOINTMENT_INFO = createAction('SHOW_APPOINTMENT_INFO');
export const HIDE_APPOINTMENT_INFO = createAction('HIDE_APPOINTMENT_INFO');
export const UPDATE_APPOINTMENTS_TOTAL_COUNT = createAction('UPDATE_APPOINTMENTS_TOTAL_COUNT');


export const showAppointmentInfo = (appointmentId) => (dispatch, getState) => {
  const tempAppId = appointmentId || getState().appointmentInfo.currentAppointment.appointmentId;
  return Promise.resolve(dispatch({
    type: SHOW_APPOINTMENT_INFO,
    payload: { appointmentId: tempAppId },
  }));
};

export const hideAppointmentInfo = () => (dispatch, getState) => {
  const state = getState();
  const { isInternetSlow } = state.conference.internetMeter;

  if (isInternetSlow) {
    return Promise.resolve()
      .then(() => dispatch(onPing(2)))
      .then(() => dispatch({ type: HIDE_APPOINTMENT_INFO }));
  }

  return Promise.resolve(dispatch({ type: HIDE_APPOINTMENT_INFO }));
};


export const updateAppointmentsTotalCount = (count, queueType) => ({
  type: UPDATE_APPOINTMENTS_TOTAL_COUNT,
  payload: { queueType, count },
});
